import { Spinner as TailGridsSpinner } from '../tailgrids/core/spinner/index.js';
import { cn } from '../../utils/cn.js';

interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  /** What is loading, for screen readers ("Loading runs"). */
  label?: string;
  className?: string;
}

/**
 * An in-progress indicator (NextAdmin spinner) for a short wait inside a control or panel. For content that is loading,
 * prefer `Skeleton` in the content's shape. Never hand-roll `animate-spin`.
 */
export function Spinner({ size = 'sm', label = 'Loading', className }: SpinnerProps) {
  return (
    <span role="status" aria-label={label} className={cn('inline-flex items-center justify-center', className)}>
      <TailGridsSpinner size={size} />
    </span>
  );
}
